import IconCustom from "./icon-custom";

export default IconCustom;
